import {setDirectChatData} from '@/redux-store/slices/matrix/room-data';
import {store} from '@/redux-store/store';
import {MatrixClient, AccountDataEvents} from 'matrix-js-sdk';

export const updateDirectChatData = async (
  client: MatrixClient,
  userId: string,
  roomId: string
) => {
  try {
    const directMap: Record<string, string[]> =
      client
        .getAccountData('m.direct' as keyof AccountDataEvents)
        ?.getContent() || {};

    const newDirectMap = {
      ...directMap,
      [userId]: [roomId]
    };

    store.dispatch(setDirectChatData(newDirectMap));
    await client.setAccountData(
      'm.direct' as keyof AccountDataEvents,
      newDirectMap
    );
  } catch (error) {
    console.warn('Error updating direct chat data:', error);
  }
};
